import { createContext } from "react";

const CurrentUserContext = createContext(null);

export default CurrentUserContext;